export default __webpack_public_path__ + "95e880a4d7844e06aad9c91a8bc099ae.svg";